import { render, staticRenderFns } from "./Merge.vue?vue&type=template&id=19131c5d&scoped=true"
import script from "./Merge.vue?vue&type=script&lang=js"
export * from "./Merge.vue?vue&type=script&lang=js"
import style0 from "./Merge.vue?vue&type=style&index=0&id=19131c5d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19131c5d",
  null
  
)

export default component.exports